<template>
  <div class="box" v-bind:style="{width: `${size}px`, height: `${size}px`}">
    <div
      class="inner"
      v-bind:style="{'background-color': `${bg}`, color: `${font}`}"
      v-bind:class="{pulse: pulse && this.$store.getters.running}"
    >
      <template v-if="typeof time === 'number'">
        <span class="text">
          {{time > 12 ? time - 12 : time == 0 ? 12 : time}}
          <span
            class="am-pm"
          >{{time >= 12 && time != 24 ? "PM" : "AM"}}</span>
        </span>
      </template>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "ActivityBox",
  props: {
    size: Number,
    time: [Boolean, Number],
    score: Number
  },
  data() {
    return {
      pulse: moment().hours() == this.time
    };
  },
  mounted() {},
  computed: {
    bg: function() {
      if (this.score == 0) return "white";
      else if (this.score >= 1 && this.score < 2) return "#51b84733";
      else if (this.score >= 2 && this.score < 4) return "#51b84766";
      else if (this.score >= 4 && this.score < 6) return "#51b847BB";
      else if (this.score >= 6 && this.score < 8) return "#51b847";
      else if (this.score >= 8 && this.score < 10) return "#409438";
      else return "#FFD700";
    },
    font: function() {
      if (this.score <= 1) return "#444";
      // else if (this.score >= 1 && this.score < 7) return '#333';
      // else if (this.score >= 7 && this.score < 10) return '#EEE';
      else return "#FFF";
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.box {
  margin-top: auto;
  margin-bottom: auto;
  text-align: center;
  padding: 5px;
}
.am-pm {
  font-variant: small-caps;
  font-size: 5pt;
}
.inner {
  height: 100%;
  font-size: 10px;
  box-shadow: 1px 1px 3px #00000026;
  padding-top: 8px;
}
.pulse {
  animation: pulse 2s infinite;
}
@keyframes pulse {
  0% {
    box-shadow: 0px 0px 0px #00000026;
  }
  70% {
    box-shadow: 1px 1px 8px #00000026;
  }
  100% {
    box-shadow: 0px 0px 0px #00000026;
  }
}
</style>
